import { Component, OnInit, signal } from '@angular/core';
import { LanguageModel } from 'src/app/api/models/language-model';
import { TranslationService } from 'src/app/api/services/translation.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';
import { TranslationEventService } from '../../../services/translation-event.service';

@Component({
  selector: 'app-language-dropdown',
  templateUrl: './language-dropdown.component.html',
  standalone: true,
  imports: [MatOption, MatSelect, MatFormFieldModule],
  host: {
    class: '!p-0 relative',
  },
})
export class LanguageDropdownComponent implements OnInit {
  languages = signal<LanguageModel[]>([]);

  constructor(
    private authService: AuthService,
    private translationService: TranslationService,
    protected translationEventService: TranslationEventService,
  ) {}

  ngOnInit(): void {
    this.loadLanguages();
  }

  loadLanguages(): void {
    if (this.languages().length > 0) {
      return;
    }

    this.translationService
      .listLanguagesGet(this.authService.getApiKeyHeaders())
      .subscribe({
        next: (languageList) => {
          this.languages.set(languageList.availableLanguages);
        },
        error: (err) => {
          console.error('Failed to load languages:', err);
        },
      });
  }

  onLanguageSelected(model: LanguageModel): void {
    this.translationEventService.selectedLanguage.set(model);
  }
}
